import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import { useAuth } from "../contexts/auth";
import axios from 'axios';
import { getSelectedLanguageFromLocalStorage, getUserFromLocalStorage } from "../utils/localStorage-utils";

export const BASE_URL_ADMIN =
    process.env.REACT_APP_URL_ADMIN + (process.env.REACT_APP_PORT_ADMIN ? `:${process.env.REACT_APP_PORT_ADMIN}` : "")

export const BASE_URL_AUDIT =
    process.env.REACT_APP_URL_AUDIT + (process.env.REACT_APP_PORT_AUDIT ? `:${process.env.REACT_APP_PORT_AUDIT}` : "")

export const BASE_URL_HR =
    process.env.REACT_APP_URL_HR + (process.env.REACT_APP_PORT_HR ? `:${process.env.REACT_APP_PORT_HR}` : "")


const createAxiosInstance = (baseUrl) => {
    const selectedLanguage = getSelectedLanguageFromLocalStorage()
    const user = getUserFromLocalStorage()
    return axios.create({
        baseURL: baseUrl,
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': selectedLanguage == null ? 'tr-TR' : selectedLanguage,
            'TenantId': user?.tenantId
        },
    })
}

const useAxiosPrivate = (axiosObject, contentType = "form") => {
    //console.log("contentType",contentType)
    const refresh = useRefreshToken();

    const { user, setUser, activeLanguage } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosObject.interceptors.request.use(
            config => {
                config.headers['TenantId'] = user?.tenantId
                config.headers['Authorization'] = `Bearer ${user?.token}`
                config.headers['Accept-Language'] = activeLanguage
                //config.headers["Content-Type"] = (contentType === "form") ? "application/x-www-form-urlencoded;charset=UTF-8" : "application/json; charset=utf-8"
                config.headers["Content-Type"] = (contentType === "form") ? "multipart/form-data" : "application/json; charset=utf-8"
//                config.headers["responseType"] = 'blob'
                return config;
            }, (error) => Promise.reject(error)
        );


        const responseIntercept = axiosObject.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401) {
                    console.log("responseIntercept 401 hatası alındı",)
                    if (prevRequest?.sent)
                        setUser(undefined)
                    else {
                        prevRequest.sent = true;

                        const newToken = await refresh(user.refreshToken);

                        if (newToken) {
                            prevRequest.headers['Authorization'] = `Bearer ${newToken}`;
                            return axiosObject(prevRequest);
                        }
                    }
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosObject.interceptors.request.eject(requestIntercept);
            axiosObject.interceptors.response.eject(responseIntercept);
        }
    }, [user, refresh, activeLanguage, contentType])

    return axiosObject;
}

export default useAxiosPrivate;

export const axiosAdminSimple = createAxiosInstance(BASE_URL_ADMIN)
export const axiosAdminPrivate = createAxiosInstance(BASE_URL_ADMIN)
export const axiosHrPrivate = createAxiosInstance(BASE_URL_HR)
export const axiosAuditPrivate = createAxiosInstance(BASE_URL_AUDIT)
